import './common-styles';
import '@/styles/dmq-cart.scss';

import './common-code';

import Vue from 'vue';
import store from '@/store';
import DmqCart from '@/components/DmqCart.vue';

Vue.config.productionTip = false;

new DmqCart({
  store,
}).$mount('#dmq-cart');
